import React, { useState } from "react";
import { useTheme } from "styled-components";
import { AnimatePresence, motion } from "framer-motion";
import { Flex } from "../Flex";
import { zIndex as styledComponentsZIndex, ZFlyout } from "../../styled_components";
import { CollapsePanelButton } from "./internal/CollapsePanelButton";
import { FlyoutHeading } from "./internal/FlyoutHeading";
/**
 * A flyout is a component that displays content in a sliding side panel on the right side of the screen.
 * Flyouts can be collapsed and expanded without losing the current state of the content.
 */
export const Flyout = ({ "data-testid": dataTestId = "flyout", children, headerIcon, height = "100vh", isCollapsable = true, isCollapsed: isCollapsedProp, maxWidth = "100vw", onClose, title, top = 0, width, zIndex = styledComponentsZIndex(ZFlyout), }) => {
    const [isCollapsed, setCollapsed] = useState(Boolean(isCollapsedProp));
    const { colors: { flyoutColors }, } = useTheme();
    const motionDivStyle = {
        display: "flex",
        flexDirection: "column",
        height,
        overflow: "hidden",
        // Padding to account for the panel shadow
        paddingLeft: "8px",
        position: "fixed",
        right: 0,
        top,
        zIndex,
    };
    return (React.createElement(AnimatePresence, null,
        React.createElement(motion.div, { "data-testid": dataTestId, key: "motion-id-widget-drawer", initial: { x: "calc(100% - 41px)" }, animate: { x: isCollapsed ? "calc(100% - 41px)" : "0" }, exit: { x: "calc(100% - 41px)" }, transition: { damping: 32, stiffness: 400, type: "spring" }, style: motionDivStyle },
            React.createElement(Flex, { height: "100%" },
                isCollapsable && React.createElement(CollapsePanelButton, { isCollapsed: isCollapsed, setCollapsed: setCollapsed }),
                React.createElement(Flex, { backgroundColor: flyoutColors.flyoutBackground, boxShadow: "-4px 0px 4px 0px #00000010", "data-testid": "flyout-container", flexDirection: "column", height: "100%", maxWidth: maxWidth, role: "dialog", width: width },
                    React.createElement(FlyoutHeading, { headerIcon: headerIcon, onCloseHandler: onClose, title: title }),
                    React.createElement(Flex, { flexDirection: "column", flexGrow: 1, overflow: "auto" }, children))))));
};
